import { Driver, DriverHook } from "driver.js";
import { defaultTourConfig } from ".";
import { profileSetupTourSteps } from "./ProfileSetupTour";
import { brandsAndProgramsTourSteps } from "./BrandsAndProgramsTour";
import { affiliatesPayoutsTourSteps } from "./AffiliatesPayoutsTour";
import { tourManager } from "@/utils/tourManager";
import { getAffiliateWelcomeTourSteps } from "./AffiliateWelcomeTour";
import { filterMarketplaceSteps } from "./marketplaceSteps";

const startGrandTour = (
  tourDriver: Driver,
  onNextClick: DriverHook,
  onPrevClick: DriverHook,
  isMarketplaceHidden = false,
  portalName = "Reveshare"
) => {
  tourDriver.setConfig(defaultTourConfig);

  // Combine all tour steps in the specified order
  const allSteps = filterMarketplaceSteps(
    [
      ...getAffiliateWelcomeTourSteps(portalName),
      ...profileSetupTourSteps,
      ...brandsAndProgramsTourSteps,
      ...affiliatesPayoutsTourSteps,
    ],
    isMarketplaceHidden
  );

  // Add navigation handlers to each step
  const stepsWithHandlers = allSteps.map((step, index) => ({
    ...step,
    popover: {
      ...step.popover,
      onNextClick: (element: Element | undefined, step: any, config: any) => {
        onNextClick(element, step, config);

        // Check if this is the last step
        if (index === allSteps.length - 1) {
          // User has completed the tour - mark it as completed
          tourManager.completeGrandTour();
        }

        setTimeout(() => {
          tourDriver.moveNext();
        }, 200);
      },
      onPrevClick: (element: Element | undefined, step: any, config: any) => {
        onPrevClick(element, step, config);
        setTimeout(() => {
          tourDriver.movePrevious();
        }, 200);
      },
    },
  }));

  tourDriver.setSteps(stepsWithHandlers);
  tourDriver.drive();
};

export default startGrandTour;
